enum OrderStep {
  UserData,
  Delivery,
  ResultStep,
  Payment,
  Success
}

export default OrderStep
